import type { GraphicsRequirements } from '@/graphics/GraphicsRequirements'
import type { EngineContext } from '@/runtime/EngineContext'
import type { Plugin } from '@/shared/types/plugin'
import { createVideoRenderService, type VideoRenderService } from './VideoRenderService'

export class VideoRenderPlugin implements Plugin {
  readonly name = 'videoRender'
  /**
   * VideoRender 依赖离屏 target 与帧读回两项能力，另有编码运行时要求（由 preset 预检判定）。
   * 不引入单独的 `videoCapture` 能力字段：可用性由 offscreenTarget + readback + 编码运行时 + requirements 组合推导。
   */
  readonly graphicsRequirements: GraphicsRequirements = Object.freeze({
    backends: Object.freeze(['webgl2', 'webgpu'] as const),
    capabilities: Object.freeze(['offscreenTarget', 'readback'] as const),
  })
  readonly priority = 90
  readonly provides = ['VideoRenderService'] as const

  #service: VideoRenderService | null = null

  onInit(context: EngineContext): void {
    this.#service = createVideoRenderService({
      capabilities: context.graphics.capabilities,
      hasVideoEncoder:
        typeof (globalThis as { VideoEncoder?: unknown }).VideoEncoder === 'function',
    })
    context.registerService('VideoRenderService', this.#service)
  }

  onStart(): void {}

  onDestroy(): void {
    this.#service = null
  }
}
